import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Currency from "../../../components/Currency";
import ImageLoader from "../../../components/ImageLoader";

const useStyles = makeStyles(theme => ({
  cart: {
    width: "200px",
    height: "100vh",
    position: "fixed",
    top: 0,
    right: 0,
    backgroundColor: theme.palette.background.paper,
    borderLeft: "1px solid",
    borderLeftColor: theme.palette.divider
  },
  empty: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.text.secondary
  },
  icon: {
    fontSize: "2rem"
  },
  text: {
    textAlign: "center",
    fontSize: "1rem"
  },
  header: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.text.secondary,
    borderBottom: "1px solid",
    borderBottomColor: theme.palette.divider
  },
  button: {
    width: "80%",
    margin: theme.spacing(2, "auto"),
    display: "block",
    borderRadius: "30px"
  },
  items: {
    height: "calc(100vh - 206px)",
    overflow: "auto"
  },
  item: {
    padding: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid",
    borderBottomColor: theme.palette.divider
  },
  avatar: {
    width: "35px",
    height: "35px",
    borderRadius: "30px",
    overflow: "hidden",

    "& img": {
      width: "100%",
      objectFit: "contain"
    }
  },
  details: {
    padding: theme.spacing(0, 1),
    flexGrow: 1
  },
  total: {
    fontSize: "0.9rem"
  },
  quantityPrice: {
    fontSize: "0.7rem",
    color: theme.palette.text.secondary
  },
  remove: {
    fontSize: "1.25rem",
    background: "none",
    border: "none",
    borderRadius: "none"
  }
}));

const Cart = ({ items, total, onStartPaymentWizard, onDeleteItem }) => {
  const classes = useStyles();

  return items.length === 0 ? (
    <aside className={clsx(classes.cart, classes.empty)}>
      <div className={classes.icon}>
        <i className="fa fa-shopping-cart"></i>
      </div>
      <div className={classes.text}>Agrega productos a tu carrito</div>
    </aside>
  ) : (
    <aside className={classes.cart}>
      <div className={classes.header}>
        <div className={classes.icon}>
          <i className="fa fa-shopping-cart"></i>
        </div>
        <div className={classes.text}>tu carrito</div>
      </div>

      <div className={classes.items}>
        {items.map((item, index) => (
          <div key={`item-${index}`} className={classes.item}>
            <div className={classes.avatar}>
              <ImageLoader
                imgKey={item.product.medias[0].key}
                className={classes.avatar}
                circularProgressSize={20}
                title={item.product.name}
              />
            </div>
            <div className={classes.details}>
              <div className={classes.total}>
                <Currency value={item.total} />
              </div>
              <div className={classes.quantityPrice}>
                {item.quantity} x {<Currency value={item.price} />}
              </div>
            </div>
            <button className={classes.remove} onClick={() => onDeleteItem(item, index)}>
              <i className="fa fa-trash"></i>
            </button>
          </div>
        ))}
        <Button
          className={classes.button}
          variant="contained"
          color="secondary"
          onClick={onStartPaymentWizard}
        >
          Ir a pagar <Currency value={total} />
        </Button>
      </div>
    </aside>
  );
};

export default Cart;
